"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableX = void 0;
require("./index.scss");
require("datatables.net-dt/css/jquery.dataTables.css");
require("datatables.net");
//@ts-ignore (jquery _does_ expose a default. In es6, it's the one we should use)
var jquery_1 = __importDefault(require("jquery"));
var lodash_es_1 = require("lodash-es");
var lodash_es_2 = require("lodash-es");
var __1 = require("../");
var faTableIcon = __importStar(require("@fortawesome/free-solid-svg-icons/faTable"));
var TableXResults_1 = require("../TableXResults");
var XLSX = __importStar(require("xlsx"));
var ColumnResizer = require("column-resizer");
var DEFAULT_PAGE_SIZE = 50;
function expand(event) {
    (0, __1.addClass)(this, "expanded");
    event.preventDefault();
}
var TableX = /** @class */ (function () {
    function TableX(yasr) {
        var _this = this;
        this.persistentConfig = {};
        // public helpReference = "https://github.com/sparna-git/sparnatural-yasgui-plugins";
        this.label = "Table";
        this.priority = 10;
        this.setEllipsisHandlers = function () {
            var _a;
            (_a = _this.dataTable) === null || _a === void 0 ? void 0 : _a.cells({ page: "current" }).every(function (rowIdx, colIdx) {
                var _a, _b;
                var cell = (_a = _this.dataTable) === null || _a === void 0 ? void 0 : _a.cell(rowIdx, colIdx);
                if ((cell === null || cell === void 0 ? void 0 : cell.data()) === "")
                    return;
                var cellNode = cell === null || cell === void 0 ? void 0 : cell.node();
                if (cellNode) {
                    var content = cellNode.firstChild;
                    if ((((_b = content.firstElementChild) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) || 0) >
                        content.getBoundingClientRect().width) {
                        if (!content.classList.contains("expandable")) {
                            (0, __1.addClass)(content, "expandable");
                            content.addEventListener("click", expand, { once: true });
                        }
                    }
                    else {
                        if (content.classList.contains("expandable")) {
                            (0, __1.removeClass)(content, "expandable");
                            content.removeEventListener("click", expand);
                        }
                    }
                }
            });
        };
        this.handleTableSearch = function (event) {
            var _a;
            (_a = _this.dataTable) === null || _a === void 0 ? void 0 : _a.search(event.target.value).draw("page");
        };
        this.handleTableSizeSelect = function (event) {
            var _a;
            var pageLength = parseInt(event.target.value);
            // Set page length
            (_a = _this.dataTable) === null || _a === void 0 ? void 0 : _a.page.len(pageLength).draw("page");
            // Store in persistentConfig
            _this.persistentConfig.pageSize = pageLength;
            _this.yasr.storePluginConfig("table", _this.persistentConfig);
        };
        this.handleSetCompactToggle = function (event) {
            // Store in persistentConfig
            _this.persistentConfig.compact = event.target.checked;
            // Update the table
            _this.draw(_this.persistentConfig);
            _this.yasr.storePluginConfig("table", _this.persistentConfig);
        };
        this.handleSetEllipsisToggle = function (event) {
            // Store in persistentConfig
            _this.persistentConfig.isEllipsed = event.target.checked;
            // Update the table
            _this.draw(_this.persistentConfig);
            _this.yasr.storePluginConfig("table", _this.persistentConfig);
        };
        this._downloadHandlerSetup = false;
        this.yasr = yasr;
        this.results = undefined;
        //TODO read options from constructor
        this.config = TableX.defaults;
    }
    // ***** end TableX MODIFICATION
    TableX.prototype.getIcon = function () {
        return (0, __1.drawSvgStringAsElement)((0, __1.drawFontAwesomeIconAsSvg)(faTableIcon));
    };
    // ***** TableX MODIFICATION
    TableX.prototype.postProcessRawResults = function (results) {
        if (results) {
            return new TableXResults_1.TableXResults(results, this.config.bindingSetAdapter);
        }
    };
    TableX.prototype.getRows = function () {
        if (!this.results)
            return [];
        var bindings = this.results.getBindings();
        console.log("bindings :", bindings);
        console.log("yasr :", this.yasr.results);
        if (!bindings)
            return [];
        // Vars decide the columns
        var vars = this.results.getVariables();
        // Use "" as the empty value, undefined will throw runtime errors
        return bindings.map(function (binding, rowId) { return __spreadArray([
            rowId + 1
        ], vars.map(function (variable) { var _a; return (_a = binding[variable]) !== null && _a !== void 0 ? _a : ""; }), true); });
    };
    TableX.prototype.getUriLinkFromBinding = function (binding, prefixes) {
        // ***** TableX MODIFICATION
        var href = this.config.uriHrefAdapter
            ? this.config.uriHrefAdapter(binding.value)
            : binding.value;
        var visibleString = binding.value;
        // ***** TableX MODIFICATION
        var prefixed = false;
        if (prefixes) {
            for (var prefixLabel in prefixes) {
                if (visibleString.indexOf(prefixes[prefixLabel]) == 0) {
                    visibleString =
                        prefixLabel + ":" + href.substring(prefixes[prefixLabel].length);
                    prefixed = true;
                    break;
                }
            }
        }
        // Hide brackets when prefixed or compact
        var hideBrackets = prefixed || this.persistentConfig.compact;
        return "".concat(hideBrackets ? "" : "&lt;", "<a class='iri' target='").concat(this.config.openIriInNewWindow ? "_blank" : "_self", "'").concat(this.config.openIriInNewWindow ? " ref='noopener noreferrer'" : "", " href='").concat(href, "'>").concat(visibleString, "</a>").concat(hideBrackets ? "" : "&gt;");
    };
    // ***** TableX MODIFICATION
    TableX.prototype.getLabelledUriLinkFromBinding = function (binding) {
        var href = this.config.uriHrefAdapter
            ? this.config.uriHrefAdapter(binding.value)
            : binding.value;
        var visibleString = binding.label;
        // Hide brackets when prefixed or compact
        return "<a class='iri' target='".concat(this.config.openIriInNewWindow ? "_blank" : "_self", "'").concat(this.config.openIriInNewWindow ? " ref='noopener noreferrer'" : "", " href='").concat(href, "'>").concat(visibleString, "</a>");
    };
    // ***** end TableX MODIFICATION
    TableX.prototype.getCellContent = function (binding, prefixes) {
        var content;
        if (binding.type == "uri") {
            content = "<span>".concat(this.getUriLinkFromBinding(binding, prefixes), "</span>");
            // ***** TableX MODIFICATION
        }
        else if (binding.type == "x-labelled-uri") {
            content = "<span>".concat(this.getLabelledUriLinkFromBinding(binding), "</span>");
            // ***** end TableX MODIFICATION
        }
        else {
            content = "<span class='nonIri'>".concat(this.formatLiteral(binding, prefixes), "</span>");
        }
        return "<div>".concat(content, "</div>");
    };
    TableX.prototype.formatLiteral = function (literalBinding, prefixes) {
        var stringRepresentation = (0, lodash_es_1.escape)(literalBinding.value);
        // Return now when in compact mode.
        if (this.persistentConfig.compact)
            return stringRepresentation;
        if (literalBinding["xml:lang"]) {
            stringRepresentation = "\"".concat(stringRepresentation, "\"<sup>@").concat(literalBinding["xml:lang"], "</sup>");
        }
        else if (literalBinding.datatype) {
            // ***** TableX MODIFICATION
            if (literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#date") {
                // format the date according to the locale
                var date = new Date(literalBinding.value);
                stringRepresentation = date.toLocaleDateString(this.config.lang);
            }
            else if (literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#dateTime") {
                // format the date according to the locale
                var date = new Date(literalBinding.value);
                stringRepresentation = date.toLocaleString(this.config.lang);
            }
            else if (literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#gYear") {
                stringRepresentation = literalBinding.value;
            }
            else if (literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#integer" ||
                literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#int" ||
                literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#long" ||
                literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#float" ||
                literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#double") {
                stringRepresentation = literalBinding.value;
            }
            else if (literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#boolean") {
                var translations = {
                    en: {
                        true: "True",
                        false: "False",
                    },
                    fr: {
                        true: "Vrai",
                        false: "Faux",
                    },
                    de: {
                        true: "Wahr",
                        false: "Falsch",
                    },
                };
                stringRepresentation = ((this.config.lang &&
                    translations[this.config.lang]) ||
                    translations["en"])[literalBinding.value];
                if (stringRepresentation == undefined) {
                    stringRepresentation = literalBinding.value;
                }
            }
            else if (literalBinding.datatype == "http://www.w3.org/2001/XMLSchema#string") {
                stringRepresentation = literalBinding.value;
            }
            else {
                var dataType = this.getUriLinkFromBinding({ type: "uri", value: literalBinding.datatype }, prefixes);
                stringRepresentation = "\"".concat(stringRepresentation, "\"<sup>^^").concat(dataType, "</sup>");
            }
            // ***** end TableX MODIFICATION
        }
        return stringRepresentation;
    };
    TableX.prototype.getColumns = function () {
        var _this = this;
        var _a;
        if (!this.results)
            return [];
        var prefixes = this.yasr.getPrefixes();
        return __spreadArray([
            // this is the special row number column, which is hidden when in "compact mode"
            {
                name: "",
                searchable: false,
                width: "".concat(this.getSizeFirstColumn(), "px"),
                type: "num",
                orderable: false,
                visible: this.persistentConfig.compact !== true,
                render: function (data, type) {
                    return type === "filter" || type === "sort" || !type
                        ? data
                        : "<div class=\"rowNumber\">".concat(data, "</div>");
                },
            }
        ], (_a = this.results) === null || _a === void 0 ? void 0 : _a.getVariables().map(function (name) {
            return {
                name: name,
                title: name,
                visible: _this.persistentConfig.compact
                    ? _this.config.excludeColumnsFromCompactView.indexOf(name) == -1
                    : true,
                render: function (data, type, _row, _meta) {
                    // Handle empty rows
                    if (data === "")
                        return data;
                    if (type === "filter" || type === "sort" || !type) {
                        // ***** TableX MODIFICATION
                        // for sorting : sort on label and not on URI
                        if (data.type == "x-labelled-uri") {
                            return data.label;
                        }
                        else {
                            return data.value;
                        }
                        // ***** end TableX MODIFICATION
                    }
                    return _this.getCellContent(data, prefixes);
                },
            };
        }), true);
    };
    TableX.prototype.getSizeFirstColumn = function () {
        var _a, _b;
        var numResults = ((_b = (_a = this.results) === null || _a === void 0 ? void 0 : _a.getBindings()) === null || _b === void 0 ? void 0 : _b.length) || 0;
        return numResults.toString().length * 8;
    };
    TableX.prototype.draw = function (persistentConfig) {
        var _this = this;
        var _a, _b;
        // ***** TableX MODIFICATION
        this.results = this.postProcessRawResults(this.yasr.results);
        // in addition, replace all references to this.yasr.results to to this.results
        // ***** end TableX MODIFICATION
        this.persistentConfig = __assign(__assign({}, this.persistentConfig), persistentConfig);
        this.tableEl = document.createElement("table");
        var rows = this.getRows();
        var columns = this.getColumns();
        if (rows.length <= ((persistentConfig === null || persistentConfig === void 0 ? void 0 : persistentConfig.pageSize) || DEFAULT_PAGE_SIZE)) {
            this.yasr.pluginControls;
            (0, __1.addClass)(this.yasr.rootEl, "isSinglePage");
        }
        else {
            (0, __1.removeClass)(this.yasr.rootEl, "isSinglePage");
        }
        if (this.dataTable) {
            this.destroyResizer();
            this.dataTable.destroy(true);
            this.dataTable = undefined;
        }
        this.yasr.resultsEl.appendChild(this.tableEl);
        // reset some default config properties as they couldn't be initialized beforehand
        var dtConfig = __assign(__assign({}, (0, lodash_es_2.cloneDeep)(this.config.tableConfig)), { pageLength: (persistentConfig === null || persistentConfig === void 0 ? void 0 : persistentConfig.pageSize)
                ? persistentConfig.pageSize
                : DEFAULT_PAGE_SIZE, data: rows, columns: columns });
        this.dataTable = (0, jquery_1.default)(this.tableEl).DataTable(dtConfig);
        this.tableEl.style.removeProperty("width");
        this.tableEl.style.width = this.tableEl.clientWidth + "px";
        var widths = Array.from(this.tableEl.querySelectorAll("th")).map(function (h) { return h.offsetWidth - 26; });
        this.tableResizer = new ColumnResizer.default(this.tableEl, {
            widths: this.persistentConfig.compact === true
                ? widths
                : __spreadArray([this.getSizeFirstColumn()], widths.slice(1), true),
            partialRefresh: true,
            onResize: this.persistentConfig.isEllipsed !== false && this.setEllipsisHandlers,
            headerOnly: true,
        });
        // DataTables uses the rendered style to decide the widths of columns.
        // Before a draw remove the ellipseTable styling
        if (this.persistentConfig.isEllipsed !== false) {
            (_a = this.dataTable) === null || _a === void 0 ? void 0 : _a.on("preDraw", function () {
                var _a, _b, _c;
                (_a = _this.tableResizer) === null || _a === void 0 ? void 0 : _a.reset({ disable: true });
                (0, __1.removeClass)(_this.tableEl, "ellipseTable");
                (_b = _this.tableEl) === null || _b === void 0 ? void 0 : _b.style.removeProperty("width");
                (_c = _this.tableEl) === null || _c === void 0 ? void 0 : _c.style.setProperty("width", _this.tableEl.clientWidth + "px");
                return true; // Indicate it should re-render
            });
            // After a draw
            (_b = this.dataTable) === null || _b === void 0 ? void 0 : _b.on("draw", function () {
                var _a, _b;
                if (!_this.tableEl)
                    return;
                // Width of table after render, removing width will make it fall back to 100%
                var targetSize = _this.tableEl.clientWidth;
                _this.tableEl.style.removeProperty("width");
                // Let's make sure the new size is not bigger
                if (targetSize > _this.tableEl.clientWidth)
                    targetSize = _this.tableEl.clientWidth;
                (_a = _this.tableEl) === null || _a === void 0 ? void 0 : _a.style.setProperty("width", "".concat(targetSize, "px"));
                // Enable the re-sizer
                (_b = _this.tableResizer) === null || _b === void 0 ? void 0 : _b.reset({
                    disable: false,
                    partialRefresh: true,
                    onResize: _this.setEllipsisHandlers,
                    headerOnly: true,
                });
                // Re-add the ellipsis
                (0, __1.addClass)(_this.tableEl, "ellipseTable");
                // Check if cells need the ellipsisHandlers
                _this.setEllipsisHandlers();
            });
        }
        this.drawControls();
        // Draw again but with the events
        if (this.persistentConfig.isEllipsed !== false) {
            (0, __1.addClass)(this.tableEl, "ellipseTable");
            this.setEllipsisHandlers();
        }
        // if (this.tableEl.clientWidth > width) this.tableEl.parentElement?.style.setProperty("overflow", "hidden");
    };
    /**
     * Draws controls on each update
     */
    TableX.prototype.drawControls = function () {
        var _a;
        // Remove old header
        this.removeControls();
        this.tableControls = document.createElement("div");
        this.tableControls.className = "tableControls";
        if (this.config.includeControls) {
            // Compact switch
            var toggleWrapper = document.createElement("div");
            var switchComponent = document.createElement("label");
            var textComponent = document.createElement("span");
            textComponent.innerText = "Simple view";
            (0, __1.addClass)(textComponent, "label");
            switchComponent.appendChild(textComponent);
            (0, __1.addClass)(switchComponent, "switch");
            toggleWrapper.appendChild(switchComponent);
            this.tableCompactSwitch = document.createElement("input");
            switchComponent.addEventListener("change", this.handleSetCompactToggle);
            this.tableCompactSwitch.type = "checkbox";
            switchComponent.appendChild(this.tableCompactSwitch);
            this.tableCompactSwitch.defaultChecked = !!this.persistentConfig.compact;
            this.tableControls.appendChild(toggleWrapper);
            // Ellipsis switch
            var ellipseToggleWrapper = document.createElement("div");
            var ellipseSwitchComponent = document.createElement("label");
            var ellipseTextComponent = document.createElement("span");
            ellipseTextComponent.innerText = "Ellipse";
            (0, __1.addClass)(ellipseTextComponent, "label");
            ellipseSwitchComponent.appendChild(ellipseTextComponent);
            (0, __1.addClass)(ellipseSwitchComponent, "switch");
            ellipseToggleWrapper.appendChild(ellipseSwitchComponent);
            this.tableEllipseSwitch = document.createElement("input");
            ellipseSwitchComponent.addEventListener("change", this.handleSetEllipsisToggle);
            this.tableEllipseSwitch.type = "checkbox";
            ellipseSwitchComponent.appendChild(this.tableEllipseSwitch);
            this.tableEllipseSwitch.defaultChecked =
                this.persistentConfig.isEllipsed !== false;
            this.tableControls.appendChild(ellipseToggleWrapper);
            // Create table filter
            this.tableFilterField = document.createElement("input");
            this.tableFilterField.className = "tableFilter";
            this.tableFilterField.placeholder = "Filter query results";
            this.tableFilterField.setAttribute("aria-label", "Filter query results");
            this.tableControls.appendChild(this.tableFilterField);
            this.tableFilterField.addEventListener("keyup", this.handleTableSearch);
        }
        // Create page wrapper
        var pageSizerWrapper = document.createElement("div");
        pageSizerWrapper.className = "pageSizeWrapper";
        // Create label for page size element
        var pageSizerLabel = document.createElement("span");
        pageSizerLabel.textContent = "Page size: ";
        pageSizerLabel.className = "pageSizerLabel";
        pageSizerWrapper.appendChild(pageSizerLabel);
        // Create page size element
        this.tableSizeField = document.createElement("select");
        this.tableSizeField.className = "tableSizer";
        // Create options for page sizer
        var options = [10, 50, 100, 1000, -1];
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            var element = document.createElement("option");
            element.value = option + "";
            // -1 selects everything so we should call it All
            element.innerText = option > 0 ? option + "" : "All";
            // Set initial one as selected
            if (((_a = this.dataTable) === null || _a === void 0 ? void 0 : _a.page.len()) === option)
                element.selected = true;
            this.tableSizeField.appendChild(element);
        }
        pageSizerWrapper.appendChild(this.tableSizeField);
        this.tableSizeField.addEventListener("change", this.handleTableSizeSelect);
        this.tableControls.appendChild(pageSizerWrapper);
        this.yasr.pluginControls.appendChild(this.tableControls);
    };
    // download method to provide custom download functionality
    TableX.prototype.download = function (filename) {
        var _this = this;
        // Setup the download handler on the download button
        this._setupDownloadHandler();
        return {
            getData: function () { var _a; return ((_a = _this.yasr.results) === null || _a === void 0 ? void 0 : _a.asCsv()) || ""; },
            contentType: "text/csv",
            title: "Download result",
            filename: "".concat(filename || "queryResults", ".csv"),
        };
    };
    // Méthode pour configurer le gestionnaire de clic sur le bouton de téléchargement
    TableX.prototype._setupDownloadHandler = function () {
        var _this = this;
        if (this._downloadHandlerSetup)
            return;
        setTimeout(function () {
            var _a;
            var downloadBtn = document.querySelector(".yasr_downloadIcon");
            if (!downloadBtn)
                return;
            var newBtn = downloadBtn.cloneNode(true);
            (_a = downloadBtn.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newBtn, downloadBtn);
            newBtn.classList.add("download-enabled");
            newBtn.title = "Télécharger les résultats";
            newBtn.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this._showFormatMenu(newBtn);
            });
            _this._downloadHandlerSetup = true;
        }, 100);
    };
    // Menu de choix du format de téléchargement
    TableX.prototype._showFormatMenu = function (button) {
        var _this = this;
        var _a;
        // Supprimer un ancien menu s'il existe
        (_a = document.querySelector(".format-menu")) === null || _a === void 0 ? void 0 : _a.remove();
        var menu = document.createElement("div");
        menu.className = "format-menu";
        menu.style.cssText = "\n    position: fixed;\n    background: white;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n    padding: 5px 0;\n    border-radius: 4px;\n    z-index: 10000;\n  ";
        var formats = [
            { label: "CSV", format: "csv" },
            { label: "XLSX", format: "xlsx" },
            { label: "ODS", format: "ods" },
        ];
        // Construire les éléments du menu
        formats.forEach(function (item) {
            var option = document.createElement("div");
            option.textContent = item.label;
            option.style.cssText = "\n      padding: 6px 15px;\n      cursor: pointer;\n      white-space: nowrap;\n    ";
            option.addEventListener("mouseover", function () { return (option.style.background = "#f0f0f0"); });
            option.addEventListener("mouseout", function () { return (option.style.background = "transparent"); });
            option.addEventListener("click", function (e) {
                e.stopPropagation();
                cleanup();
                _this._downloadData(item.format);
            });
            menu.appendChild(option);
        });
        document.body.appendChild(menu);
        // Position initiale sous le bouton
        var rect = button.getBoundingClientRect();
        menu.style.top = "".concat(rect.bottom + 6, "px");
        menu.style.left = "".concat(rect.left, "px");
        // Ajustement si le menu dépasse l'écran
        var menuRect = menu.getBoundingClientRect();
        var overflowRight = menuRect.right - window.innerWidth;
        var overflowLeft = menuRect.left;
        if (overflowRight > 0) {
            var adjustedLeft = rect.left - overflowRight - 10; // marge 10px
            menu.style.left = "".concat(Math.max(10, adjustedLeft), "px");
        }
        else if (overflowLeft < 0) {
            menu.style.left = "10px";
        }
        // Fonction interne pour tout nettoyer
        var cleanup = function () {
            menu.remove();
            document.removeEventListener("click", handleClickOutside);
            window.removeEventListener("scroll", handleScroll);
        };
        // Fermer si clic en dehors
        var handleClickOutside = function (e) {
            if (!menu.contains(e.target) && e.target !== button)
                cleanup();
        };
        document.addEventListener("click", handleClickOutside);
        // Fermer au premier scroll
        var handleScroll = function () { return cleanup(); };
        window.addEventListener("scroll", handleScroll, { once: true });
    };
    // Télécharge le fichier dans le format choisi
    TableX.prototype._downloadData = function (format) {
        if (format === void 0) { format = "xlsx"; }
        if (!this.results) {
            alert("Aucun résultat à exporter.");
            return;
        }
        var filename = "queryResults";
        var workbook = this._createWorkbook();
        // Conversion via SheetJS
        var wbout = XLSX.write(workbook, { bookType: format, type: "array" });
        var blob = new Blob([wbout]);
        var url = URL.createObjectURL(blob);
        // Lancer le téléchargement
        var link = document.createElement("a");
        link.href = url;
        link.download = "".concat(filename, ".").concat(format);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () { return URL.revokeObjectURL(url); }, 100);
    };
    // Génère le classeur Excel a partir Yasr
    TableX.prototype._createWorkbook = function () {
        var workbook = XLSX.utils.book_new();
        // Récupération des résultats YASR
        var yasrResults = this.yasr.results;
        if (!yasrResults)
            return workbook;
        // Récupération des colonnes et lignes via les méthodes publiques du Parser
        var vars = yasrResults.getVariables() || [];
        var bindings = yasrResults.getBindings() || [];
        // Préparation du tableau pour SheetJS
        var data = [vars];
        bindings.forEach(function (binding) {
            var row = [];
            vars.forEach(function (variable) {
                var cell = binding[variable];
                if (!cell) {
                    row.push("");
                }
                else {
                    // On prend value
                    row.push(cell.value || "");
                }
            });
            data.push(row);
        });
        // Génération de la feuille Excel
        var sheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, sheet, "Results");
        return workbook;
    };
    TableX.prototype.canHandleResults = function () {
        return (!!this.yasr.results &&
            this.yasr.results.getVariables() &&
            this.yasr.results.getVariables().length > 0);
    };
    TableX.prototype.removeControls = function () {
        var _a, _b, _c, _d, _e, _f;
        // Unregister listeners and remove references to old fields
        (_a = this.tableFilterField) === null || _a === void 0 ? void 0 : _a.removeEventListener("keyup", this.handleTableSearch);
        this.tableFilterField = undefined;
        (_b = this.tableSizeField) === null || _b === void 0 ? void 0 : _b.removeEventListener("change", this.handleTableSizeSelect);
        this.tableSizeField = undefined;
        (_c = this.tableCompactSwitch) === null || _c === void 0 ? void 0 : _c.removeEventListener("change", this.handleSetCompactToggle);
        this.tableCompactSwitch = undefined;
        (_d = this.tableEllipseSwitch) === null || _d === void 0 ? void 0 : _d.removeEventListener("change", this.handleSetEllipsisToggle);
        this.tableEllipseSwitch = undefined;
        // Empty controls
        while ((_e = this.tableControls) === null || _e === void 0 ? void 0 : _e.firstChild)
            this.tableControls.firstChild.remove();
        (_f = this.tableControls) === null || _f === void 0 ? void 0 : _f.remove();
    };
    TableX.prototype.destroyResizer = function () {
        if (this.tableResizer) {
            this.tableResizer.reset({ disable: true });
            window.removeEventListener("resize", this.tableResizer.onResize);
            this.tableResizer = undefined;
        }
    };
    TableX.prototype.destroy = function () {
        var _a;
        this.removeControls();
        this.destroyResizer();
        // According to datatables docs, destroy(true) will also remove all events
        (_a = this.dataTable) === null || _a === void 0 ? void 0 : _a.destroy(true);
        this.dataTable = undefined;
        (0, __1.removeClass)(this.yasr.rootEl, "isSinglePage");
    };
    // ***** end TableX MODIFICATION
    TableX.defaults = {
        openIriInNewWindow: true,
        includeControls: false,
        tableConfig: {
            dom: "tip",
            pageLength: DEFAULT_PAGE_SIZE,
            lengthChange: true,
            data: [],
            columns: [],
            order: [],
            deferRender: true,
            orderClasses: false,
            language: {
                paginate: {
                    first: "&lt;&lt;",
                    last: "&gt;&gt;",
                    next: "&gt;",
                    previous: "&lt;", // <
                },
            },
        },
        excludeColumnsFromCompactView: [],
        uriHrefAdapter: undefined,
        lang: "en",
    };
    return TableX;
}());
exports.TableX = TableX;
